/* Shared customiser "Size guide" behaviour — see snippets/size-guide.liquid.

   Open/close is universal and self-binding, so a section only has to render
   the snippet. Everything a customiser knows and this file doesn't — which
   size is selected, which sizes the current finish can't be bought in, which
   way the print is turned — comes back through SkylitSizeGuide.sync() /
   .setOrientation(), called from that customiser's own refresh function.

   The panel is informational only. It deliberately sits outside the
   claim-mode lock (design-claim.js) that freezes the real size pickers: there
   is nothing here to lock, since it never writes state. */
(function () {
  'use strict';

  var BOUND = 'sklSgBound';
  var UNITS_KEY = 'skylitSizeUnits';
  var units = 'cm';

  /* Units are a page-wide choice, not a per-panel one. Moon renders one picker
     (and so one panel) per product type, and a customer who switched to inches
     on one of them would be baffled to find the next in centimetres. Reading
     and writing a single module-level value keeps every panel in lockstep for
     free, and localStorage carries it between customisers and visits.

     Only the LABELS change. Frame geometry is derived from real cm through
     flex-grow/aspect-ratio in the CSS, so nothing here can move a frame — which
     is exactly why the chart cannot drift out of true when units flip. */
  function readStoredUnits() {
    try {
      var v = window.localStorage.getItem(UNITS_KEY);
      return v === 'in' ? 'in' : 'cm';
    } catch (e) {
      // Private browsing / storage disabled — fall back to the default, don't throw.
      return 'cm';
    }
  }

  function applyUnits(next, persist) {
    units = next === 'in' ? 'in' : 'cm';
    var attr = units === 'in' ? 'data-label-in' : 'data-label-cm';
    Array.prototype.forEach.call(document.querySelectorAll('.skl-sg__label[data-label-cm]'), function (el) {
      var text = el.getAttribute(attr);
      if (text) el.textContent = text;
    });
    var noteAttr = units === 'in' ? 'data-note-in' : 'data-note-cm';
    Array.prototype.forEach.call(document.querySelectorAll('.skl-sg__note[data-note-cm]'), function (el) {
      var text = el.getAttribute(noteAttr);
      if (text) el.textContent = text;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-size-guide-units]'), function (btn) {
      var on = btn.getAttribute('data-size-guide-units') === units;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (persist) {
      try { window.localStorage.setItem(UNITS_KEY, units); } catch (e) { /* nothing to do */ }
    }
  }

  // Delegated once at the document, so panels rendered later (moon swaps its
  // pickers per product type) need no rebinding.
  if (!document.documentElement.dataset.sklSgUnitsBound) {
    document.documentElement.dataset.sklSgUnitsBound = '1';
    document.addEventListener('click', function (e) {
      // The whole cm/in pill is one switch: any tap inside it flips to the
      // other unit, so nobody has to precision-hit the inactive label.
      var group = e.target && e.target.closest && e.target.closest('[data-size-guide-units-group]');
      if (!group) return;
      applyUnits(units === 'in' ? 'cm' : 'in', true);
    });
  }

  function init(root) {
    var scope = root || document;
    var btns = scope.querySelectorAll('[data-size-guide-toggle]');
    Array.prototype.forEach.call(btns, function (btn) {
      if (btn.dataset[BOUND]) return;
      btn.dataset[BOUND] = '1';
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('data-size-guide-toggle'));
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
        // A followed picker that was inside a hidden step when the page
        // loaded could not be read then, and switching steps mutates the step
        // container rather than the picker, so nothing re-triggers the
        // observer. Opening the guide is the moment its contents matter —
        // re-read the picker here rather than watching the whole page.
        if (!panel.hidden && typeof panel.sklSgRead === 'function') panel.sklSgRead();
      });
    });

    // Declarative wiring: a size picker tagged data-size-guide-picker="<uid>"
    // gets followed with no per-customiser JS at all. Star map opts out of
    // this and calls sync() itself, because its refresh function already
    // knows which sizes the current finish can't be bought in.
    var pickers = scope.querySelectorAll('[data-size-guide-picker]');
    Array.prototype.forEach.call(pickers, function (picker) {
      if (picker.dataset[BOUND]) return;
      picker.dataset[BOUND] = '1';
      follow(picker.getAttribute('data-size-guide-picker'), picker, {
        itemSelector: picker.getAttribute('data-size-guide-tile') || undefined,
        activeSelector: picker.getAttribute('data-size-guide-active') || undefined,
        codeAttr: picker.getAttribute('data-size-guide-code') || undefined
      });
    });

    // Same idea for a portrait/landscape switch: tag its container and the
    // guide's frames turn with it. Location map binds this through Alpine
    // instead, since its orientation already lives in an Alpine store.
    var switches = scope.querySelectorAll('[data-size-guide-orientation]');
    Array.prototype.forEach.call(switches, function (group) {
      if (group.dataset[BOUND]) return;
      group.dataset[BOUND] = '1';
      var uid = group.getAttribute('data-size-guide-orientation');
      var activeSelector = group.getAttribute('data-size-guide-active') || '.active,.active__picker,.is-active,.selected';
      var read = function () {
        var on = Array.prototype.filter.call(
          group.querySelectorAll('[data-orientation]'),
          function (el) { return el.matches(activeSelector); }
        )[0];
        setOrientation(uid, on ? on.getAttribute('data-orientation') : 'portrait');
      };
      group.addEventListener('click', function () { setTimeout(read, 0); });
      new MutationObserver(read).observe(group, {
        subtree: true, attributes: true, attributeFilter: ['class']
      });
      read();
    });

    // Late-rendered panels start life in cm markup; re-apply so they match a
    // choice made before they existed.
    applyUnits(readStoredUnits(), false);
  }

  function panelOf(ref) {
    if (!ref) return null;
    if (typeof ref === 'string') {
      return document.getElementById(ref.indexOf('skl-sg-') === 0 ? ref : 'skl-sg-' + ref);
    }
    return ref;
  }

  /* opts.selected — size code to highlight ('a4', '30x40', …)
     opts.hidden   — array of size codes to drop (unavailable for this finish).
                     A hidden item is never also the active one, so the panel
                     can't highlight something the customer cannot buy. */
  function sync(ref, opts) {
    var panel = panelOf(ref);
    if (!panel) return;
    var o = opts || {};
    var hidden = o.hidden || [];
    var selected = (o.selected || '').toString().toLowerCase();
    Array.prototype.forEach.call(panel.querySelectorAll('[data-size-guide-item]'), function (item) {
      var code = item.getAttribute('data-size-guide-item');
      var gone = hidden.indexOf(code) !== -1;
      item.style.display = gone ? 'none' : '';
      item.classList.toggle('is-active', !gone && code === selected);
    });
  }

  function setOrientation(ref, orientation) {
    var panel = panelOf(ref);
    if (!panel) return;
    panel.classList.toggle('skl-sg--landscape', orientation === 'landscape');
  }

  function normalize(v) {
    return (v || '').toString().toLowerCase().replace(/cm/g, '').replace(/\s+/g, '').trim();
  }

  /* follow(uid, pickerEl, opts) — mirror a size picker without touching the
     customiser's own state code. Star map calls sync() directly because its
     refresh function already knows everything; the older customisers each
     express selection differently (.active, .active__picker, Alpine :class),
     so instead of teaching this file four conventions it just watches the
     picker: whichever tile matches activeSelector is the selected one, and a
     tile the customiser has hidden (display:none, e.g. 60x80 on canvas) drops
     out of the guide too.

     Sold-out tiles are deliberately NOT dropped — they stay visible in the
     picker, so hiding them here would make the two disagree.

     opts.itemSelector  — tiles within the picker
     opts.activeSelector— what "selected" looks like in this customiser
     opts.codeAttr      — attribute holding the size, normalised to '40x50' form */
  function follow(ref, picker, opts) {
    var panel = panelOf(ref);
    if (!panel || !picker) return;
    var o = opts || {};
    var itemSelector = o.itemSelector || '[data-size-code],[data-option],[data-variant-option]';
    var activeSelector = o.activeSelector || '.active,.active__picker,.is-active,.selected';
    var codeAttr = o.codeAttr;

    function codeOf(el) {
      var raw = codeAttr ? el.getAttribute(codeAttr) : null;
      if (raw == null) raw = el.getAttribute('data-size-code') || el.getAttribute('data-option');
      return normalize(raw);
    }

    function read() {
      // A picker inside a hidden wrapper (moon renders one per product type)
      // reports every tile as invisible — reading it would blank the guide.
      if (picker.offsetParent === null && picker.getClientRects().length === 0) return;
      var hidden = [];
      var selected = '';
      Array.prototype.forEach.call(picker.querySelectorAll(itemSelector), function (el) {
        var code = codeOf(el);
        if (!code) return;
        if (el.offsetParent === null && el.getClientRects().length === 0) hidden.push(code);
        else if (el.matches(activeSelector)) selected = code;
      });
      sync(panel, { selected: selected, hidden: hidden });
    }

    picker.addEventListener('click', function () { setTimeout(read, 0); });
    new MutationObserver(function () { read(); }).observe(picker, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style']
    });
    read();
    panel.sklSgRead = read;
    return read;
  }

  window.SkylitSizeGuide = {
    init: init, sync: sync, setOrientation: setOrientation, follow: follow,
    setUnits: function (u) { applyUnits(u, true); },
    getUnits: function () { return units; }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
